/*
 * SHŌRI cart preview
 * Shows a compact, non-blocking cart preview after an item is added.
 * Manual opening through the header cart icon keeps the same mobile drawer width.
 */
(function () {
  var previewTimer;
  var cleanupTimer;
  var previewDuration = 3500;

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function addPreviewStyles() {
    if (document.getElementById('shori-cart-preview-styles')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'shori-cart-preview-styles';
    style.textContent = `
      cart-drawer.shori-cart-preview .drawer__underlay {
        background: rgba(0, 0, 0, 0.12);
        pointer-events: none;
      }

      @media only screen and (max-width: 749px) {
        /* The normal cart and product-added preview always share this full-height drawer. */
        cart-drawer .drawer__inner {
          top: 0;
          right: auto;
          bottom: 0;
          left: 100vw;
          width: 70vw;
          max-width: none;
          height: auto;
          min-height: 100vh;
          min-height: 100dvh;
          max-height: none;
          border-left: 1px solid var(--border);
          border-radius: 0;
          box-shadow: -12px 0 32px rgba(0, 0, 0, 0.18);
        }

        /* Preserve room for the price while allowing long product names to wrap. */
        cart-drawer .cart__item__content {
          grid-template-columns: minmax(0, 1fr) max-content;
          gap: 8px;
        }

        cart-drawer .cart__item__content__left {
          min-width: 0;
        }

        cart-drawer .cart__item__content__right {
          min-width: max-content;
          white-space: nowrap;
        }

        cart-drawer .cart__item__price,
        cart-drawer .cart__price {
          white-space: nowrap;
          overflow-wrap: normal;
          word-break: normal;
        }

        cart-drawer .cart__item__price {
          font-size: max(13px, var(--font-body-small));
          line-height: 1.2;
        }

        /* Product-added preview enters from the right and ends at the same 70% width. */
        cart-drawer.shori-cart-preview .drawer__inner {
          top: 0;
          right: 0;
          bottom: 0;
          left: auto;
          width: 70vw;
          max-width: none;
          height: auto;
          min-height: 100vh;
          min-height: 100dvh;
          max-height: none;
          transform: translateX(100%);
          animation: none;
        }

        cart-drawer.shori-cart-preview.is-open .drawer__inner {
          visibility: visible;
          animation: shori-cart-preview-in 0.35s ease forwards;
        }

        cart-drawer.shori-cart-preview.is-closing .drawer__inner {
          visibility: visible;
          animation: shori-cart-preview-out 0.28s ease forwards;
        }
      }

      /* Desktop deliberately uses Broadcast's unmodified drawer width and animation. */

      @keyframes shori-cart-preview-in {
        from { transform: translateX(100%); }
        to { transform: translateX(0); }
      }

      @keyframes shori-cart-preview-out {
        from { transform: translateX(0); }
        to { transform: translateX(100%); }
      }
    `;

    document.head.appendChild(style);
  }

  function removePreviewClass(cartDrawer) {
    if (!cartDrawer.classList.contains('is-open')) {
      cartDrawer.classList.remove('shori-cart-preview');
    }
  }

  function hideCartPreview() {
    var cartDrawer = getCartDrawer();

    if (!cartDrawer || !cartDrawer.classList.contains('shori-cart-preview')) {
      return;
    }

    cartDrawer.classList.add('is-closing');
    cartDrawer.classList.remove('is-open');
    cartDrawer.cartDrawerIsOpen = false;

    window.clearTimeout(cleanupTimer);
    cleanupTimer = window.setTimeout(function () {
      cartDrawer.classList.remove('is-closing', 'shori-cart-preview');
    }, 350);
  }

  function showCartPreview() {
    var cartDrawer = getCartDrawer();

    if (!cartDrawer) {
      return;
    }

    addPreviewStyles();
    window.clearTimeout(previewTimer);
    window.clearTimeout(cleanupTimer);

    if (cartDrawer.cartDrawerIsOpen && !cartDrawer.classList.contains('shori-cart-preview')) {
      return;
    }

    cartDrawer.classList.remove('is-closing');
    cartDrawer.classList.add('shori-cart-preview', 'is-open');
    cartDrawer.cartDrawerIsOpen = true;

    document.dispatchEvent(
      new CustomEvent('theme:cart-drawer:open', {
        detail: { target: cartDrawer },
        bubbles: true
      })
    );

    previewTimer = window.setTimeout(hideCartPreview, previewDuration);
  }

  function bindCartPreview() {
    var cartDrawer = getCartDrawer();

    if (!cartDrawer || !cartDrawer.openCartDrawerOnProductAdded) {
      return;
    }

    /* Add layout rules at page load so manual cart opening never falls back to 100% width. */
    addPreviewStyles();

    document.removeEventListener(
      'theme:product:added',
      cartDrawer.openCartDrawerOnProductAdded
    );
    document.removeEventListener('theme:product:added', showCartPreview);
    document.addEventListener('theme:product:added', showCartPreview);

    if (!cartDrawer.hasAttribute('data-shori-cart-preview-bound')) {
      cartDrawer.setAttribute('data-shori-cart-preview-bound', 'true');

      cartDrawer.addEventListener('theme:cart-drawer:show', function () {
        window.clearTimeout(previewTimer);
        window.clearTimeout(cleanupTimer);
        cartDrawer.classList.remove('shori-cart-preview', 'is-closing');
      });

      document.addEventListener('theme:cart-drawer:close', function () {
        window.clearTimeout(previewTimer);
        window.clearTimeout(cleanupTimer);
        cleanupTimer = window.setTimeout(function () {
          removePreviewClass(cartDrawer);
        }, 350);
      });
    }
  }

  bindCartPreview();
  document.addEventListener('shopify:section:load', bindCartPreview);
})();
